import React, { useState } from "react";
import { useOutletContext } from "react-router";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import utc from "dayjs/plugin/utc";

import DataFetcher from "../../../components/DataFetcher";
import { OutlineButton } from "../../../components/Button";
import AccountUpgradeDetailsModal from "./AccountUpgradeDetailsModal";
import { formatAccts } from "../../../utils/helpers";

dayjs.extend(advancedFormat);
dayjs.extend(utc);

const AccountUpgradeRequestsPage = () => {
  const [setPageTitle] = useOutletContext();
  setPageTitle("Account Upgrades");

  return (
    <DataFetcher
      url={`/account-upgrades`}
      buildUI={(data, mutate) => (
        <AccountUpgradeRequestsDisplay requests={data} mutate={mutate} />
      )}
    />
  );
};

const AccountUpgradeRequestsDisplay = ({ requests, mutate }) => {
  const [selectedReqIndex, setSelectedReqIndex] = useState(-1);

  return (
    <div>
      <h2 className="fs-20 mb-16">Account Upgrade Requests</h2>

      <div className="box">
        {!requests || requests.length === 0 ? (
          <>There is currently no pending Account Upgrade Requests</>
        ) : (
          requests.map((req, i) => (
            <div key={i} className="flex center gap info-row-with-actions">
              <div className="text">
                <h3 className="fs-20">
                  {req.customerName}
                  <span className="btn primary light fs-14 no-hover">
                    Tier {req.lowestAccountTier}
                  </span>
                </h3>
                <p className="charcoal-60">{formatAccts(req.accountNumbers)}</p>
                <p className="charcoal-60">
                  {dayjs(req.timestamp * 1000).utc().format("D - MMM - YYYY")}
                  &nbsp;&bull;&nbsp;
                  {dayjs(req.timestamp * 1000).utc().format("hh:mm")}
                </p>
              </div>

              <div className="actions">
                <OutlineButton
                  mini
                  style={{ padding: "0.6rem 2rem" }}
                  onClick={() => setSelectedReqIndex(i)}
                >
                  View Request
                </OutlineButton>
              </div>
            </div>
          ))
        )}
      </div>

      {selectedReqIndex >= 0 && (
        <AccountUpgradeDetailsModal
          mutate={mutate}
          req={requests[selectedReqIndex]}
          dismissModal={() => setSelectedReqIndex(-1)}
        />
      )}
    </div>
  );
};

export default AccountUpgradeRequestsPage;
